// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import PageTabs, { type PageTab } from './PageTabs';

const RECORDS_TABS: PageTab[] = [
  { key: 'notes', label: 'Notes', to: '/log', exact: true },
  { key: 'audit', label: 'Audit', to: '/audit', exact: true },
];

/** Records tab bar (Notes / Audit) — thin wrapper over PageTabs. */
export default function RecordsTabs() {
  return <PageTabs tabs={RECORDS_TABS} ariaLabel="Records" testIdPrefix="records-tab" />;
}
